import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelUnassignCustomerVipStatus} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class UnassignCustomerVipStatusFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.unassignCustomerVipStatus({customerId: this.props.customerId})
      .then((response) => {
        if (response.data.unassignCustomerVipStatus.errors.length <= 0) {
          this.props.cancelUnassignCustomerVipStatus();
        } else {
          let errors = createValidationErrors(response.data.unassignCustomerVipStatus.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelUnassignCustomerVipStatus();
  }

  render() {
    return (
      <Form
        message="This will unassign VIP status for the customer and will apply the current active pricelist for the shop. Their accounts will no longer have subscription prices for one-time orders, unless they have an active subscription. Do you want to proceed?"
        submitLabel="Proceed"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        errors={this.state.errors}
        />
    )
  }
}

const UNASSIGN_CUSTOMER_VIP_STATUS = gql`
  mutation unassignCustomerVipStatus($data: CustomerIdInput!) {
    unassignCustomerVipStatus(input: $data) {
      errors { key message }
    }
  }
`;


const withQueries = compose(
  graphql(UNASSIGN_CUSTOMER_VIP_STATUS, {
    props: ({ mutate }) => ({
      unassignCustomerVipStatus: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelUnassignCustomerVipStatus})(withQueries(UnassignCustomerVipStatusFormContainer));
